import { render, staticRenderFns } from "./badmintonCourt.vue?vue&type=template&id=efffb74e&"
import script from "./badmintonCourt.vue?vue&type=script&lang=js&"
export * from "./badmintonCourt.vue?vue&type=script&lang=js&"
import style0 from "./badmintonCourt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports